// Panel diagnostic — dernières erreurs de sync (table gn_sync_error_log).
// Chaque row peut être dépliée pour voir la stack trace complète.
import React, { useEffect, useState } from "react";
import { adminSyncErrors } from "../services/authService";

function formatDateTime(v) {
	if (!v) return "—";
	const d = new Date(v);
	if (isNaN(d)) return "—";
	return d.toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export default function AdminSyncErrorsPanel() {
	const [errors, setErrors] = useState([]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState(1);
	const [total, setTotal] = useState(0);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [expandedId, setExpandedId] = useState(null);

	const load = async (p) => {
		setLoading(true);
		const result = await adminSyncErrors({ page: p });
		setLoading(false);
		if (result.success) {
			setErrors(result.errors || []);
			setTotalPages(result.totalPages || 1);
			setTotal(result.total || 0);
		} else {
			setError(result.error || "Erreur");
		}
	};

	useEffect(() => { load(page); }, [page]);

	return (
		<div>
			<div className="admin-users-toolbar" style={{ marginBottom: 12 }}>
				<span style={{ color: "var(--ink-soft)", fontSize: 14 }}>
					{total} erreur{total > 1 ? "s" : ""} enregistrée{total > 1 ? "s" : ""}
				</span>
				<button className="mens-btn ghost small" onClick={() => load(page)}>Rafraîchir</button>
			</div>

			{error && <div className="admin-error">{error}</div>}
			{loading && <div className="admin-loading">Chargement...</div>}

			{!loading && errors.length === 0 && (
				<div className="admin-empty">Aucune erreur de sync enregistrée. 🎉</div>
			)}

			{!loading && errors.length > 0 && (
				<div className="sync-errors-list">
					{errors.map((e) => {
						const expanded = expandedId === e.id;
						return (
							<div key={e.id} className={`sync-error-card ${expanded ? "expanded" : ""}`}>
								<div
									className="sync-error-header"
									onClick={() => setExpandedId(expanded ? null : e.id)}
								>
									<div style={{ flex: 1 }}>
										<div className="sync-error-message">{e.errorMessage || "(pas de message)"}</div>
										<div className="sync-error-meta">
											<span>{formatDateTime(e.createdAt)}</span>
											<span>·</span>
											<span>{e.userName?.trim() || "?"} ({e.userEmail || "?"})</span>
											<span>·</span>
											<span>#{e.userId}</span>
										</div>
									</div>
									<div className="sync-error-counters">
										{e.newTrainings > 0 && <span title="Nouvelles séances">🏋 {e.newTrainings}</span>}
										{e.newTemplates > 0 && <span title="Modèles">📋 {e.newTemplates}</span>}
										{e.newReferentiels > 0 && <span title="Exercices">💪 {e.newReferentiels}</span>}
										{e.newMensurations > 0 && <span title="Mensurations">📏 {e.newMensurations}</span>}
									</div>
									<span className="sync-error-chevron">{expanded ? "▼" : "▶"}</span>
								</div>
								{expanded && e.stackTrace && (
									<pre className="sync-error-stack">{e.stackTrace}</pre>
								)}
							</div>
						);
					})}

					<div className="admin-users-pagination">
						<span>Page {page} / {totalPages}</span>
						<div>
							<button className="mens-btn ghost small" disabled={page <= 1} onClick={() => setPage(page - 1)}>← Précédent</button>
							<button className="mens-btn ghost small" disabled={page >= totalPages} onClick={() => setPage(page + 1)} style={{ marginLeft: 6 }}>Suivant →</button>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
